import { profileFailed, profileSuccess } from "./reducer"
import { RootState } from "slices";
import { ThunkAction } from "redux-thunk";
import { Action, Dispatch } from "redux";
import logger from '../../../utils/logger';
import userService, { UpdateProfileDto } from '../../../services/user.service';

/**
 * Edit user profile via backend API
 * Uses the userService to communicate with web/user/profile endpoint
 */
export const editProfile = (
    profileData: UpdateProfileDto
): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch: Dispatch) => {
    try {
        logger.info('Updating user profile...');

        const response = await userService.updateProfile(profileData);

        if (response.statusCode === 200 && response.data) {
            dispatch(profileSuccess(response.data));
            logger.info('Profile updated successfully');
        } else {
            throw new Error(response.message || 'Failed to update profile');
        }
    } catch (error: any) {
        const errorMessage = error?.message || 'Failed to update profile';
        logger.error('Profile update failed:', error);
        dispatch(profileFailed(errorMessage));
    }
};

/**
 * Get current user profile from backend
 */
export const fetchProfile = (): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch: Dispatch) => {
    try {
        logger.info('Fetching user profile...');

        const response = await userService.getProfile();

        if (response.statusCode === 200 && response.data) {
            dispatch(profileSuccess(response.data));
            logger.info('Profile fetched successfully');
        } else {
            throw new Error(response.message || 'Failed to fetch profile');
        }
    } catch (error: any) {
        const errorMessage = error?.message || 'Failed to fetch profile';
        logger.error('Profile fetch failed:', error);
        dispatch(profileFailed(errorMessage));
    }
};
